import {

    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, TextareaAutosize,
    TextField
} from "@material-ui/core";

import DescriptionIcon from '@mui/icons-material/Description';


 import React, { useState} from "react";
import axios from "axios";
import { api } from "./api/client";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from '@mui/material/Button';
import IconButton from "@mui/material/IconButton";

export default function ModalboxReddedilen(props) {
    const [open, setOpen] = useState(false);
    const [state, setState] = useState({
        id:props.id,
        red_notlari:props.red_notlari,
        tur: !!props.tur
    });

    const handleChange = name => e => {
        setState({
            ...state,
            [name]: e.target.value
        });
        console.log('state change',state);
    };

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>

            <IconButton size="small" style={{width:30}}   onClick={handleClickOpen}  color="error"  variant="outlined" target={"_blank"} title={'Reddet'} > <CancelIcon /></IconButton>

             <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                maxWidth="md"
            >
                 <DialogTitle id="form-dialog-title">{state.tur ? 'İptal İş Emirlerine Gönder' : 'Teklif Reddedilme Notu' }</DialogTitle>
                <DialogContent>
                    <DialogContentText  >

                        {state.tur ? 'İptal edilen iş emirlerine gönderilsin mi?' : 'Notları Giriniz' }
                    </DialogContentText>

                    <TextareaAutosize
                        style={props.tur ? {display:"none"} : {display:"block", width: 400}}
                        margin="dense"
                        id="red_notlari"
                        label="Notlar"
                        type="tel"
                        value={state.red_notlari || ""}
                        onChange={handleChange("red_notlari")}
                        fullWidth
                        multiline
                        minRows="8"

                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        {state.tur ? 'Hayır' : 'İptal' }

                    </Button>
                    <Button

                        onClick={

                            async () => {

                                !props.tur ?
                             await api.post('/teklifler/' + props.id + '/iptal?id=' + props.id, {
                                 'red_notlari': state.red_notlari
                             })
                                .then((response) => {
                                    // Success 🎉
                                    console.log(response);
                                    handleClose();
                                    props.reddEdilmis(true);
                                    window.location.reload()
                                })
                                .catch((error) => {
                                    // Error 😨
                                    if (error.response) {
                                        /*
                                         * The request was made and the server responded with a
                                         * status code that falls out of the range of 2xx
                                         */
                                        console.log(error.response.data);
                                        console.log(error.response.status);
                                        console.log(error.response.headers);
                                    } else if (error.request) {
                                        /*
                                         * The request was made but no response was received, `error.request`
                                         * is an instance of XMLHttpRequest in the browser and an instance
                                         * of http.ClientRequest in Node.js
                                         */
                                        console.log(error.request);
                                    } else {
                                        // Something happened in setting up the request and triggered an Error
                                        console.log('Error', error.message);
                                    }
                                    console.log(error.config);
                                }):
                                    // iş emirleri iptali için

                                    await api.post('/is-emirleri/' + props.id + '/iptal?id=' + props.id, {
                                        'durum': 'Iptal',
                                        'notu': state.red_notlari
                                    })
                                        .then((response) => {
                                            // Success 🎉
                                            console.log(response);
                                            handleClose();
                                            props.reddEdilmis(true);
                                        })
                                        .catch((error) => {
                                            // Error 😨
                                            if (error.response) {
                                                /*
                                                 * The request was made and the server responded with a
                                                 * status code that falls out of the range of 2xx
                                                 */
                                                console.log(error.response.data);
                                                console.log(error.response.status);
                                                console.log(error.response.headers);
                                            } else if (error.request) {
                                                /*
                                                 * The request was made but no response was received, `error.request`
                                                 * is an instance of XMLHttpRequest in the browser and an instance
                                                 * of http.ClientRequest in Node.js
                                                 */
                                                console.log(error.request);
                                            } else {
                                                // Something happened in setting up the request and triggered an Error
                                                console.log('Error', error.message);
                                            }
                                            console.log(error.config);
                                        })
                            setState({open:false});
                        }}
                        color="primary"
                    >
                        {state.tur ? 'Evet' : 'Kaydet' }

                    </Button>
                </DialogActions>
            </Dialog></div>
    )
}

